// extracted by mini-css-extract-plugin
export default {"root":"ProgressOverlay_root__BwFsC","content":"ProgressOverlay_content__OSHS6","message":"ProgressOverlay_message__ZPykl h4","spinner":"ProgressOverlay_spinner__YOu6b"};